<template>
	<div class="fc-event-title-wrapper" :class="wrapperStyles">
		<event-time
			:multi-day="!isAllDay && multipleDays"
			:recurring-icon="isRecurring"
		>
			{{ eventTimeDisplayString }}
		</event-time>
		<event-title
			v-if="shouldShowPrimaryTitle"
			:class="titleStyles"
			:has-requests="hasRequests"
		>
			{{ event.title }}
		</event-title>

		<event-subtitle
			v-if="
				showSecondaryTitle && (hasSecondary || hasLinkedPartnerCalendar)
			"
			:class="subtitleStyles"
			:calendar-icon="hasLinkedPartnerCalendar"
		>
			{{ subTitleText }}
		</event-subtitle>
	</div>
</template>

<script>
import moment from 'moment'
import Event from './Event.vue'

/**
 * FullCalendar event cell for the public share calendar.
 * Supports toggling primary/secondary provider labels (expand detail).
 */
export default {
	extends: Event,

	name: 'PublicShareEvent',

	props: {
		/**
		 * Whether to show the primary provider title.
		 *
		 * @type {Boolean}
		 */
		showPrimaryTitle: {
			type: Boolean,
			default: false,
		},

		/**
		 * Whether to show the secondary provider subtitle.
		 *
		 * @type {Boolean}
		 */
		showSecondaryTitle: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		/**
		 * Use the real event end when the public calendar clamps layout to
		 * the start day so the label still shows the original range.
		 *
		 * @return {Moment}
		 */
		end() {
			const originalEnd = this.extendedProps?.originalEnd

			if (originalEnd) {
				return moment(originalEnd)
			}

			return moment(this.event.end)
		},

		/**
		 * Always show the primary title when there is no secondary provider.
		 * Otherwise follow the expand-detail toggle.
		 *
		 * @return {Boolean}
		 */
		shouldShowPrimaryTitle() {
			return this.showPrimaryTitle || !this.hasSecondary
		},

		/**
		 * Keep the provider color class only. The linked-partner modifier
		 * hides the title's bottom border so it can join the subtitle.
		 *
		 * @return {Array}
		 */
		titleStyles() {
			return [this.displayColor?.bgClass]
		},

		/**
		 * Do not join title and subtitle corners on the public calendar.
		 *
		 * @return {Object}
		 */
		wrapperStyles() {
			return {
				'multi-day-event': this.multipleDays,
			}
		},
	},
}
</script>
